export const listStyles = {
    '.opt-list': {
        background: 'var(--surface)',
        borderRadius: 'var(--radius-md)',
        padding: 'var(--spacing-md)',
        boxShadow: 'var(--shadows-sm)'
    },
    '.opt-list-title': {
        fontSize: 'var(--typography-fontSize-lg)',
        fontWeight: 'var(--typography-fontWeight-semibold)',
        color: 'var(--text-primary)',
        marginBottom: 'var(--spacing-md)'
    },
    '.opt-list-item': {
        display: 'flex',
        alignItems: 'center',
        padding: 'var(--spacing-sm)',
        borderBottom: '1px solid var(--border-light)'
    },
    '.opt-list-item:last-child': {
        borderBottom: 'none'
    },
    '.opt-list-item-icon': {
        width: '40px',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--background-light)',
        borderRadius: 'var(--radius-sm)',
        marginRight: 'var(--spacing-sm)'
    },
    '.opt-list-item-content': {
        flex: '1'
    },
    '.opt-list-item-title': {
        fontWeight: 'var(--typography-fontWeight-medium)',
        color: 'var(--text-primary)'
    },
    '.opt-list-item-subtitle': {
        fontSize: 'var(--typography-fontSize-sm)',
        color: 'var(--text-secondary)'
    },
    '.opt-list-item-meta': {
        display: 'flex',
        gap: 'var(--spacing-sm)',
        alignItems: 'center'
    }
};